"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Information = function Information(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M12.5 6.90096C12.8596 6.90096 13.1511 6.60948 13.1511 6.24992C13.1511 5.89036 12.8596 5.59888 12.5 5.59888C12.1404 5.59888 11.849 5.89036 11.849 6.24992C11.849 6.60948 12.1404 6.90096 12.5 6.90096Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.6667 18.2291H13.0208V10.4166C13.0209 10.3482 13.0074 10.2804 12.9813 10.2172C12.9551 10.154 12.9168 10.0966 12.8684 10.0482C12.82 9.99982 12.7626 9.96145 12.6994 9.9353C12.6362 9.90914 12.5684 9.8957 12.5 9.89575H8.33333C8.1952 9.89575 8.06272 9.95063 7.96505 10.0483C7.86737 10.146 7.8125 10.2785 7.8125 10.4166C7.8125 10.5547 7.86737 10.6872 7.96505 10.7849C8.06272 10.8825 8.1952 10.9374 8.33333 10.9374H11.9792V18.2291H8.33333C8.1952 18.2291 8.06272 18.284 7.96505 18.3816C7.86737 18.4793 7.8125 18.6118 7.8125 18.7499C7.8125 18.8881 7.86737 19.0205 7.96505 19.1182C8.06272 19.2159 8.1952 19.2708 8.33333 19.2708H16.6667C16.8048 19.2708 16.9373 19.2159 17.035 19.1182C17.1326 19.0205 17.1875 18.8881 17.1875 18.7499C17.1875 18.6118 17.1326 18.4793 17.035 18.3816C16.9373 18.284 16.8048 18.2291 16.6667 18.2291Z",
    fill: props.foregroundColor
  }));
};

Information.defaultProps = {
  altText: "Information",
  foregroundColor: "#2D5AB4"
};
Information.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Information;
exports.default = _default;